import { render, staticRenderFns } from "./DevicesByUnityTable.vue?vue&type=template&id=83d371ba&scoped=true&"
import script from "./DevicesByUnityTable.vue?vue&type=script&lang=js&"
export * from "./DevicesByUnityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d371ba",
  null
  
)

export default component.exports